import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { DocumentComponent } from './document.component';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FavoriteService,
  AnalyticsService,
  AuthService,
  PostHogService,
  FeatureFlagService
} from '@icullen/api/shared';
import { MatTabGroup } from '@angular/material/tabs';
import { UpgradeSubscriptionInfo } from '../demo/subscribe/upgrade-subscription-info.model';
import { ResetDocumentTabEventService } from './reset-document-tab-event.service';
import { TopicsService } from '@icullen/api/site';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'document-desktop',
  templateUrl: './document-desktop.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./document-desktop.component.scss'],
})
export class DocumentDesktopComponent
  extends DocumentComponent
  implements OnInit
{
  activeTab: string;
  leftColClass = 'col-xl-9';
  rightColClass = 'col-xl-3';
  otherVersionsTab = { tableTab: false, tabName: 'OtherVersions' };
  titleWithButtons = '';

  @ViewChild('tabs', { static: false }) tabGroup: MatTabGroup;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    favoriteService: FavoriteService,
    analyticsService: AnalyticsService,
    authService: AuthService,
    cdr: ChangeDetectorRef,
    topicsService: TopicsService,
    viewportScroller: ViewportScroller,
    private resetDocumentTabService: ResetDocumentTabEventService,
    private postHogService: PostHogService,
    featureFlagService: FeatureFlagService
  ) {
    super(
      router,
      activatedRoute,
      favoriteService,
      analyticsService,
      authService,
      topicsService,
      cdr,
      featureFlagService,
      viewportScroller
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.resetDocumentTabService.resetDocumentTabSubject.subscribe((value) => {
      this.resetTabToFirst(value);
    });
  }

  resetTabToFirst(otherVersionClicked: boolean) {
    if (this.showTabs() && otherVersionClicked && this.tabGroup) {
      this.tabGroup.selectedIndex = 0;
    }
  }

  resetTabToFirstOnClick() {
    this.tabGroup.selectedIndex = 0;
  }


  onTabChanged(event: any) {
    this.hideRightColOnTabClick(event);

    const tabName = event.tab.textLabel;
    this.postHogService.trackTabClick(tabName);
    // this.analyticsService.trackDocumentTabClick(name, {
    //   documentType: this.docData.documentType.documentDefinitionType,
    //   documentName: this.docData.title,
    // });
  }

  hideRightColOnTabClick(event: any) {
    if (
      event.index < this.docData.tabAnchors.tabAnchorList.length &&
      this.docData.tabAnchors.tabAnchorList[event.index].tableTab
    ) {
      this.leftColClass = 'col-xl-12';
      this.rightColClass = 'Hide';
      this.titleWithButtons = 'WithActionIcons';
      this.addTableAnalyticsData(this.docData.tabAnchors.tabAnchorList[event.index]);
    } else {
      this.leftColClass = 'col-xl-9';
      this.rightColClass = 'col-xl-3';
      this.titleWithButtons = '';
    }
  }

  getSusbscriptionInfo(): UpgradeSubscriptionInfo {
    return {
      service: this.docData?.serviceName,
      uniqueNumber: this.docData?.uniqueNumber,
      company: this.currentUser?.companyId,
    };
  }

  showCountryUpdateUniqueNumber(uniqueNumber) {
    return uniqueNumber.slice(0, 14);
  }

  isFlashFormat(docData: any): { 'FlashFormat': boolean } {
    const supportedDocumentTypes = ['CJEU_CASE', 'FLASH', 'NOTE', 'REGULATORYREPORT', 'BIG5_SECTION', 'PUBLIC_DOCUMENT', 'BIG5'];
    return { 'FlashFormat': supportedDocumentTypes.includes(docData.documentType.documentDefinitionType) };
  }

  shouldApplyPaddingRight(docData: any): { 'PaddingRight': boolean } {
    const supportedDocumentTypes = ['COMPETITION_LAW_DOC', 'STATE_AID'];
    return { 'PaddingRight': !!docData.containingPublication || supportedDocumentTypes.includes(docData.documentType.documentDefinitionType) };
  }

  isTrackerFormat(docData: any): { 'TrackerFormat': boolean } {
    const supportedDocumentTypes = ['COUNTRY_PROFILE', 'TRACKER', 'COMPETITION_LAW_DOC', 'STATE_AID', 'IOT_PROFILE', 'DMA_CASE'];
    return { 'TrackerFormat': supportedDocumentTypes.includes(docData.documentType.documentDefinitionType) };
  }
}
